import React from 'react'
import AllTable from './AllTable'
import PipelineTableHeader from './PipelineTableHeader'
import styled from 'styled-components'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'


const reorder = (list, startIndex, endIndex, order) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  const listIds = []
  result.forEach(loan => {
    listIds.push(loan.id)
  })
  if (order === 'custom_sort') {
    saveList(listIds)
  }
  return result
}

const saveList = (List) => {

  localStorage.setItem('customList', JSON.stringify(List))
}

const MainTableHeader = styled.div`
  height: 20px;
  background: #568C93;
  padding: 10px 0;
  font-weight: bold;
`
class PipelineTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props
    }
    this.onDragEnd = this.onDragEnd.bind(this)
  }
  componentWillReceiveProps(nextProps) {

    this.setState({ ...nextProps })
  }
  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return
    }
    const items = reorder(
      this.state.loans,
      result.source.index,
      result.destination.index,
      this.state.order
    )

    this.setState({
      loans: items
    })
  }

  render() {
    const { toggleDraggable, csrfToken, sortByKey, isDraggable, sortLoans, order, loading, loansData, latestPredictionsForLoans } = this.props
    const { enableEdit, customerService, activeTab, showActivity, loans } = this.state
    const headers = [
      { text: 'Business',                   key: 'company_name', width: '20%', paddingLeft: true },
      { text: 'Amount',                     key: 'amount', width: '15%' },
      customerService
        ? { text: 'Partner / Bank',         key: 'partner_name', width:'10%' }
        : { text: 'Bank',                   key: 'bank_name', width:'10%' },
      { text: 'Product',                    key: 'product', width:'10%' },
      { text: 'State',                      key: 'state', width:'10%' },
      activeTab === 'all'
        ? { text: 'Days Since Assigned',    key: 'days_since_assigned', width:'15%' }
        : { text: 'Submitted to Audit On',  key: 'audit_handed_off_at', width:'15%' },
      { text: 'My Action Items',            key: 'active_items', width:'20%' }
    ]

    return (
      <div className="assigned-table">
        <div className="main-table">
          <MainTableHeader>
            { activeTab != 'activity' && headers.map(header =>
              (<PipelineTableHeader
                key={`header#${header.key}`}
                title={header.text}
                headerKey={header.key}
                sortByKey={sortByKey}
                width={header.width}
                paddingLeft={header.paddingLeft}
                paddingRight={header.paddingRight}
              />)
            )
            }
          </MainTableHeader>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div ref={provided.innerRef}>
                  <AllTable
                    isDraggable={isDraggable}
                    activeTab={activeTab}
                    csrfToken={csrfToken}
                    enableEdit={enableEdit}
                    loans={loans}
                    order={order}
                    customerService={customerService}
                    showActivity={showActivity}
                    sortLoans={sortLoans}
                    toggleDraggable={toggleDraggable}
                    loading={loading}
                    latestPredictionsForLoans={latestPredictionsForLoans}
                    loansData={loansData}
                  />
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

        </div>
      </div>
    )
  }
}

export default PipelineTable
